import { ResponseData } from '@shared/types'
import { message } from 'antd'
import 'whatwg-fetch'

const TIMEOUT_CODE = 800000001

const timeout = (time: number) => new Promise((resolve, reject) => {
  setTimeout(() => resolve({
    code: TIMEOUT_CODE
  }), time)
})

const wait = (time: number) => new Promise((res, rej) => {
  setTimeout(() => res(true), time)
})

export const postRequest = <T = any>(api: string, body: any) => {
  const realFetch = fetch(api, {
    mode: 'cors',
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
    .then(async res => {
      const data = await res.json()
      return data
    })

  return Promise.race<ResponseData<T>>([timeout(5000), realFetch])
}

export const putRequest = <T = any>(api: string, body: any) => {
  const realFetch = fetch(api, {
    mode: 'cors',
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
    .then(async res => {
      const data = await res.json()
      if (data.code) {
        throw data
      }
      return data
    })

  return Promise.race<ResponseData<T>>([timeout(5000), realFetch])
}

const fetch_retry = async (realFetch: () => Promise<Response>, n: number) => {
  try {
    const res = await realFetch()
    console.log('status: ', res.status, n)
    // console.log('==headers', res.headers.get('content-type'))
    // const isJson = res.headers.get('content-type').indexOf('application/json') >= 0

    if ((res.status == 404) && n > 1) {
      await wait(1900)
      return await fetch_retry(realFetch, n - 1);
    }
    const data = await res.json()
    // db not initialed, fuck serverless
    if (data.code == 10000000 && n > 1) {
      await wait(1900)
      return await fetch_retry(realFetch, n - 1);
    }
    if (data.code === 10000000) {
      message.error('服务器繁忙，请刷新试试～', 3)
    }
    return data
  } catch (err) {
    throw err;
  }
};


export const getRequest = <T = any>(api: string, query?: Record<string, string | number | boolean>) => {
  const url = new URL(api);

  Object.keys(query || {}).forEach(key => {
    if (!!query[key]) {
      url.searchParams.append(key, String(query[key]))
    }
  })

  const realFetch = () => fetch(url, {
    mode: 'cors',
    method: 'GET',
    credentials: 'include'
  })

  return Promise.race<ResponseData<T>>([timeout(10000), fetch_retry(realFetch, 1)])
}

export const deleteRequest = <T = any>(api: string) => {
  const realFetch = fetch(api, {
    mode: 'cors',
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
  })
    .then(async res => {
      const data = await res.json()
      if (data.code) {
        throw data
      }
      return data
    })

  return Promise.race<ResponseData<T>>([timeout(5000), realFetch])
}

// 判断是否需要基础域名前缀
const getBaseUrl = (url: string) => {
  // const baseURL = import.meta.env.VITE_APP_REQUEST_HOST
  const baseURL = ''
  if (/^http(s?):\/\//i.test(url)) return url
  return baseURL + url
}

// 请求拦截器
const interceptorsRequest = (config: { url: string; options?: RequestInit }) => {
  console.log('请求拦截器', config)
  const options = {
    ...config.options,
    headers: {
      ...config.options?.headers,
      // token: userStore.getState().token
    }
  }
  return { ...options }
}

// 响应拦截器
const interceptorsResponse = async <T>(options: any, response: any): Promise<ResponseData<T>> => {
  console.log('响应拦截器：', options, response)
  let data: ResponseData<T> = await response.json()

  // Format ?

  if (data.code) {
    if (response.status === 401 && data.code === 4001) {
      // Logout?
    }
    if (data.message) {
      // Alert?
    }
  }
  return data
}

// 对Headers 进行一个变形
function correctHeaders(
  method = 'GET',
  headers: HeadersInit & {
    'Content-Type'?: string
  } = {}
) {
  if (headers['Content-Type'] === 'multipart/form-data') {
    delete headers['Content-Type']
    return headers
  }
  if ((method === 'GET' || method === 'DELETE') && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  if ((method === 'POST' || method === 'PUT') && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }
  return headers
}

export const postStreams = async <T>(
  url: string,
  data?: { [key: string]: any } | string | any,
  o?: {
    headers?: HeadersInit
    options?: { [key: string]: any }
  }
) => {
  const baseUrl = getBaseUrl(url)
  const options: { [key: string]: any } = interceptorsRequest({
    url,
    options: {
      method: 'POST',
      body: JSON.stringify(data),
      headers: correctHeaders('POST', o?.headers),
      ...o?.options
    }
  })
  const response = await fetch(baseUrl, options)
  if (
    response.headers.has('Content-Type') &&
    response.headers.get('Content-Type')?.includes('application/json')
  ) {
    const responseJson = await interceptorsResponse<T>(
      {
        url,
        options
      },
      response
    )
    return responseJson
  }
  return response
}